import React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { EntityTypeToggle } from '../../components/EntityTypeToggle';
import { IApplicationState } from '../../types/redux';
import { setFavoriteEntityType } from '../../actions/filters';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { EEntityType } from '../../types/filters';
import { trackDealTypeClick } from './tracking';

export const EntityTypeToggleContainer = () => {
  const favoriteEntityType = useSelector((state: IApplicationState) => state.filters.favoriteEntityType);

  const dispatch = useDispatch();

  const setEntityType = (entityType: EEntityType | null) => {
    trackDealTypeClick(entityType);
    dispatch(setFavoriteEntityType(entityType));
    dispatch(fetchFavoriteEntities());
  };

  return <EntityTypeToggle favoriteEntityType={favoriteEntityType} setEntityType={setEntityType} />;
};
